import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { AuditLogState } from "./audit-log.slice";

/**
 * Deliberately local, narrow typing (just this module's own slice) rather
 * than importing the app-wide `RootState`/`AppDispatch` from `@vv/state`
 * - that package composes the real store by importing this module's reducer,
 * so importing back from here would be a circular workspace dependency.
 */
interface AuditLogModuleState {
  auditLog: AuditLogState;
}

type AuditLogModuleDispatch = ThunkDispatch<AuditLogModuleState, unknown, UnknownAction>;

export const useAuditLogDispatch = () => useDispatch<AuditLogModuleDispatch>();
export const useAuditLogSelector: TypedUseSelectorHook<AuditLogModuleState> = useSelector;
